export enum ReportType {
  LINE_CHART = "LINE_CHART",
  STAT_VALUE = "STAT_VALUE",
  DATA_TABLE = "DATA_TABLE"
}
